import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=fcf12b0e&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"
import style0 from "./Setting.vue?vue&type=style&index=0&id=fcf12b0e&prod&lang=css"
import style1 from "./Setting.vue?vue&type=style&index=1&id=fcf12b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf12b0e",
  null
  
)

export default component.exports